import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDevices: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDevices"><Path d="M20.25 17.5H16.5V19H20.25V17.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V16H1V21H13.5V22H23V8H21V3ZM15 20.5V9.5H21.5V20.5H15ZM13.5 17.5V19.5H2.5V17.5H13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDevices;
